import React, { useEffect, useState, } from 'react';
import '../admin.list.scss';
import { useTranslation, } from 'react-i18next';
import { useNavigate, } from 'react-router-dom';
import { ColumnsType, SorterResult, } from 'antd/lib/table/interface';
import { IPreviewVoiceRecordingTranscriptSetting, TVoiceRecordingTranscriptSettingSortableListCol, } from 'atlas-shared';
import { Table, } from 'antd';
import { AdminListPageHeader, ListPageEmpty, } from '@Components';
import { IWithListProps, IWithListSorterProps, withList, } from '@Hocs/with.list';
import { useAbilities, useAuth, useVoiceRecordingTranscriptSettings, useOrganizations, } from '@Hooks';
import { VoiceRecordingTranscriptSettingListColumns, } from '@Utils';
import { IAuth, } from '@Store';

const VoiceRecordingTranscriptSettingList = ({ filters, filtersCount, hasFilters, sorter, pagination, setQueryParams, resetQueryParams, }: IWithListProps<IPreviewVoiceRecordingTranscriptSetting, TVoiceRecordingTranscriptSettingSortableListCol>) => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const auth: IAuth = useAuth();
  const voice_recording_transcript_settings = useVoiceRecordingTranscriptSettings();
  const abilities = useAbilities();
  const [loading, setLoading, ] = useState<boolean>(true);
  const [rows, setRows, ] = useState<Array<any>>([]);
  const organizations = useOrganizations();
  
  useEffect(() => {
    if (!voice_recording_transcript_settings.loaded)
      return;
      
    setLoading(false);
    setRows((voice_recording_transcript_settings?.voice_recording_transcript_settings || []).map(row => ({ ...row, key: row.id, })));
    
  }, [voice_recording_transcript_settings, ]);

  const columns: ColumnsType<IPreviewVoiceRecordingTranscriptSetting> = React.useMemo(() => {
    return VoiceRecordingTranscriptSettingListColumns(t, navigate, false, organizations, abilities, auth, [], filters, sorter);
  }, [t, navigate, organizations, abilities, auth, filters, sorter, ]);

  return <div className='admin-list-view'>
    <AdminListPageHeader 
      t={t}
      title={t('VOICE_RECORDING_TRANSCRIPT_SETTINGS')}
      filtersCount={filtersCount}
      reset={() => resetQueryParams()}
         
    />
    <div className='table-wrp'>
      <Table
        key={loading ? 1 : 0}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pagination, filters, _sorter) => {
          const sorter: Array<SorterResult<any>> = Array.isArray(_sorter) ? _sorter : _sorter?.columnKey ? [_sorter, ] : [];

          setQueryParams({
            pagination: { current: pagination.current as number, pageSize: pagination.pageSize as number, },
            filters: Object.fromEntries(Object.entries(filters).filter(([key, value, ]) => value !== null)),
            sorter: sorter
              .filter(s => !!s.order)
              .map(s => ({ column: s.columnKey as TVoiceRecordingTranscriptSettingSortableListCol, order: s.order as IWithListSorterProps<IPreviewVoiceRecordingTranscriptSetting, TVoiceRecordingTranscriptSettingSortableListCol>['order'], })),
          });
        }}
        locale={{
          emptyText: <ListPageEmpty t={t} hasFilters={hasFilters} hasRows={!!rows.length} reset={() => resetQueryParams()} />,
        }}
      />
    </div>
  </div>;
};

export const VoiceRecordingTranscriptSettingListView = React.memo(withList<IPreviewVoiceRecordingTranscriptSetting, TVoiceRecordingTranscriptSettingSortableListCol>(VoiceRecordingTranscriptSettingList, {
  filters: {},
  sorter: [{ column: 'created_at', order: 'descend', }, ],
  pagination: { current: 1, pageSize: 10, },
}));
